import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/Auth/Password.css";
import AuthCard from "../../components/ui/Cards/AuthCard";
import Input from "../../components/ui/Input/Input";
import logo from "../../assets/images/logo1.png";
import logo3 from "../../assets/images/Frame 35.png";
import logo1 from "../../assets/images/logo3.png";
import logo2 from "../../assets/images/Frame 47.png";
// import logo3 from "../../assets/images/Frame 35.png";
import logo4 from "../../assets/images/logo7.png";
import LogoBottom from "../../assets/images/shreepuram_vijay_prateek.png";
import logo5 from "../../assets/images/logo4.png";
import { FaArrowRightToBracket } from "react-icons/fa6";
import api from "../../api/axios";
import { toast } from "react-toastify";

const ForgetPassword = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    phoneNumber: "",
  });

  useEffect(() => {
    console.log(formData.phoneNumber, "formData");
  }, [formData]);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();

    if (!formData.phoneNumber.trim()) {
      toast.error("Please enter your phone number")
      setError("Please enter your phone number");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const res = await api.post(
        `/auth/forgot-password/request-otp`,
        {
          phone: parseInt(formData.phoneNumber),
        },
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      toast.success(`OTP sent to ${formData.phoneNumber}`);
      if (res.data.message === "OTP sent for password reset") {
        {
          localStorage.setItem("otp_sent_time", Date.now().toString());
        }
        navigate("/forget-otp", {
          state: { phoneNumber: formData.phoneNumber },
        });
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to send OTP. Try again.");
      toast.error("Failed to send OTP. Try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AuthCard
        allImg={[logo3, logo2, logo4, logo5, logo1]}
        headLogo={logo}
        msgInput={
          "Please enter your mobile number below to recover your account"
        }
        title="Welcome To Bharat Jagriti ™"
        description={"EXPLORE THE TRUTH TO THE WORLD"}
        pageTitle={"Forgot Password"}
        bottomName="Powered by Sripuram"
        bottomImg={LogoBottom}
      >
        <Input
          className="forgate_password"
          placeholder={"Enter Your Mobile Number"}
          type={"tel"}
          onClickBtn={handleSubmit}
          onKeyPress={(e) => e.key === "Enter" && handleSubmit()}
          length={10}
          inputName={"phoneNumber"}
          onchangeInput={(e) => {
            const value = e.target.value;
            if (value.length <= 10) {
              setFormData({ ...formData, phoneNumber: value });
            }
          }}
          value={formData.phoneNumber}
          Button={FaArrowRightToBracket}
          CountryCode={true}
        />

        {error && (
          <p className="invalid-feedback text-center mt-3 text-red-500">
            {error}
          </p>
        )}
      </AuthCard>
    </>
  );
};

export default ForgetPassword;
